import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { ProductionLinesEntity } from "entities/ProductionLines/ProductionLinesEntity";
import { useStyles } from "./ProductionLines.styles";
import { ModalProductionLines } from "./components";
import { ProductionLinesCreationForm } from "./forms";
import { ProductionLineAccordion } from "./components/ProductionLineAccordion/ProductionLineAccordion";
import useRolesPermissions from "hooks/useRolesPermissions";

export const ProductionLines = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const routeParams = useParams();
    const { CORPORATE_PERMISSIONS } = useRolesPermissions();

    const millId = useMemo(() => Number(routeParams?.millId) || 0, [routeParams?.millId]);
    const { productionLines, refetch, setProductionLines } =
        ProductionLinesEntity.GetProductionLinesCorporateWithOrderedMCBO(millId);
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = useCallback(() => {
        refetch();
        setOpen(false);
    }, [refetch, setOpen]);

    return (
        <div className={classes.container}>
            {CORPORATE_PERMISSIONS?.corporationPermissions?.canEditProductionLines && (
                <div className={classes.buttonContainer}>
                    <Button
                        disabled={!CORPORATE_PERMISSIONS?.corporationPermissions?.canEditProductionLines}
                        className={classes.addProductionLineButton}
                        variant="text"
                        onClick={handleOpen}
                    >
                        <AddCircleIcon />{" "}
                        <Typography variant="h5" className={classes.addProductionLineButtonText}>
                            {t("corporate_backoffice.production_line_view.add_production_line_button")}
                        </Typography>
                    </Button>
                    <div className={classes.horizontalLine} />
                </div>
            )}
            {productionLines.map((productionLine) => (
                <ProductionLineAccordion
                    key={productionLine.production_line_id}
                    productionLine={productionLine}
                    refetch={refetch}
                    setProductionLines={setProductionLines}
                />
            ))}
            <ModalProductionLines
                open={open}
                handleClose={handleClose}
                title={t("corporate_backoffice.production_line_view.production_line_creation_form.modal_title")}
            >
                <ProductionLinesCreationForm handleClose={handleClose} millId={millId} />
            </ModalProductionLines>
        </div>
    );
};
